import React from 'react';
import { Select } from 'antd-v5';
import moment from 'moment';

// array of all timezones in string format
let clientbookTimezones = [
  'America/Denver',
  'America/Chicago',
  'America/New_York',
  'America/Los_Angeles',
  'Pacific/Honolulu',
  'America/Phoenix',
  'Europe/London',
  'Europe/Zurich',
  'America/Indiana/Indianapolis',
  'Australia/Sydney',
  'America/Detroit',
  'America/Vancouver',
  'America/Anchorage',
  'America/Boise',
  'America/Edmonton',
  'America/Santo_Domingo',
  'America/Grand_Turk',
  'America/Curacao',
  'America/Toronto',
  'America/St_Johns',
  'America/Halifax',
];
// we need to convert each string into it's own object to load in the select
clientbookTimezones = clientbookTimezones.map(str => ({ value: str, label: str.replace(/_/g, ' '), id: str }));

// grabs current user location and associates with a timezone
const defaultTimezone = moment.tz?.guess();

const TimezoneDropdownV2 = ({ defaultvalue, ...props }) => {
  return <Select {...props} options={clientbookTimezones} defaultValue={defaultvalue || defaultTimezone} />;
};

export { TimezoneDropdownV2 };
